import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = ({ customItems = null }) => {
  const location = useLocation();

  const renderList = (items) => (
    <ol className="flex items-center flex-wrap gap-y-1 text-sm" data-testid="breadcrumb-list">
      <li>
        <Link
          to="/"
          className="flex items-center text-gray-600 hover:text-[#E28724] transition-colors"
          data-testid="breadcrumb-home-link"
        >
          <Home className="w-4 h-4" />
        </Link>
      </li>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <li key={index} className="flex items-center">
            <ChevronRight className="w-4 h-4 text-gray-400 mx-2" />
            {!isLast && item.href ? (
              <Link
                to={item.href}
                className="text-gray-600 hover:text-[#E28724] transition-colors capitalize"
                data-testid={`breadcrumb-link-${index}`}
              >
                {item.label}
              </Link>
            ) : (
              <span
                className="text-[#1a2332] font-semibold capitalize"
                data-testid={`breadcrumb-current-${index}`}
              >
                {item.label}
              </span>
            )}
          </li>
        );
      })}
    </ol>
  );

  // If custom items provided, use them
  if (customItems) {
    return (
      <nav
        className="bg-gray-100 border-b border-gray-200 py-3 relative z-20"
        aria-label="Breadcrumb"
        data-testid="breadcrumbs-nav"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {renderList(customItems)}
        </div>
      </nav>
    );
  }

  // Auto-generate breadcrumbs from path
  const pathnames = location.pathname.split('/').filter((x) => x);

  if (pathnames.length === 0) return null;

  const breadcrumbNameMap = {
    equipment: 'Equipment',
    about: 'About Us',
    contact: 'Contact',
    faq: 'FAQ',
  };

  const items = pathnames.map((name, index) => {
    const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
    const breadcrumbName = breadcrumbNameMap[name] || name;
    return { label: breadcrumbName, href: routeTo };
  });

  return (
    <nav
      className="bg-gray-100 border-b border-gray-200 py-3 relative z-20"
      aria-label="Breadcrumb"
      data-testid="breadcrumbs-nav"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {renderList(items)}
      </div>
    </nav>
  );
};

export default Breadcrumbs;
